// extracted by mini-css-extract-plugin
export default {"ActionsCell":"e_lB_sMK","ActionsContainer":"XE3vo19V","Actions":"L1D2ld53","Numerical":"TyCSeszs","Custom":"Ki_fNjsY","left":"DCTFfGWl","right":"TMBPEHAl","center":"XC51t2KO"};